module.exports = __webpack_public_path__ + "static/media/1010686.73b10ef1.jpg";